import React from 'react';

const FacebookLikeButton = () => {
  const containerStyle = {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '20px',
  };

  const iframeHTML = `
    <iframe 
      src="https://www.facebook.com/plugins/like.php?href=https%3A%2F%2Fwww.facebook.com%2Fprofile.php%3Fid%3D61569572901195&width=450&layout&action&size&share=true&height=35&appId"
      width="450" 
      height="35" 
      style="border:none;overflow:hidden" 
      scrolling="no" 
      frameborder="0" 
      allowfullscreen="true" 
      allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share">
    </iframe>
  `;

  return (
    <div style={containerStyle} dangerouslySetInnerHTML={{ __html: iframeHTML }} />
  );
};

export default FacebookLikeButton;
